import { debounce } from '@livekatsomo/shared/utils';
import { EditorState, EditorStateConfig } from 'prosemirror-state';
import { DecorationSet } from 'prosemirror-view';
import { CustomPluginState, PluginConfig } from './types';

/**
 * Initializes the collaboration cursor plugin with the given configuration.
 * Uses debounce if a debounce time is provided.
 * @param config - The configuration for the plugin.
 * @returns A function that creates the plugin state for a given editor state configuration and instance.
 */
export function initializePlugin(
  config: PluginConfig,
): (config: EditorStateConfig, instance: EditorState) => CustomPluginState {
  return ({ doc }: EditorStateConfig) => {
    return {
      ...config,
      sendCurrentCursorPosition: config.debounceTime
        ? debounce(config.sendCurrentCursorPosition, config.debounceTime)
        : config.sendCurrentCursorPosition,
      participants: new Map(),
      queuedCursors: new Map(),
      decorationSet: doc ? DecorationSet.create(doc, []) : DecorationSet.empty,
    };
  };
}
